import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";
import { setCookie, getCookie } from "tpm-utils";

export class MeteredModal23 extends Widget {
	componentWillMount() {
		if (window.tpm_pvt.isExpired) {
			window.tpm_pvt.resetCookies();
		}

		let views = getCookie("tpm_article_views");
		if (views === null) views = 0;
		else views = parseInt(views);
		//we DO want to count the first and current article view, but the pvt might not have got to it yet
		//(race condition). If didtrack is falsy, lets increment the views to account for that
		//finally, dont do this for the fp, since that will never get counted as an article view
		if (!window.tpm_pvt || !window.tpm_pvt.didtrack) {
			if (!this.isFp) views = views + 1;
		}

		const dismissedSmallModal =
			!!getCookie("tpm_dismissed_small_modal") && this.isFp;
		const dismissedPaywall = !!getCookie("tpm_dismissed_paywall");
		const dismissedModal = !!getCookie("tpm_dismissed_modal");

		this.state.views = views;
		this.state.closed =
			views < 0 || dismissedSmallModal || (this.isFp && views < 3);
		this.state.large = views > 9 && !dismissedPaywall && !this.isFp;
		this.state.modal = !this.isFp && !dismissedModal;
		if (this.state.closed) return;

		//bind event handlers
		this.toggleClosed = this.toggleClosed.bind(this);
		this.toggleSize = this.toggleSize.bind(this);
	}

	componentDidMount() {
		const component = document.querySelector(".MeteredModal23");
		const container = component.parentElement;
		container.classList.add("MeteredModal23Container");

		if (this.isFp) container.classList.add("--fp");

		if (this.state.modal) {
			container.classList.add("--modal");
			component.classList.add("--modal");
			//for style purposes we need to move this element up in the DOM
			//but only this version
			const primary = document.querySelector(".Primary");
			primary.after(container);
		}
	}

	get whichModal() {
		let cookieVal = getCookie("tpm_next_modal");
		cookieVal = cookieVal === null ? 0 : parseInt(cookieVal);
		return cookieVal;
	}

	toggleClosed() {
		if (this.state.modal) {
			document
				.querySelector(".MeteredModal23Container")
				.setAttribute("style", "display: none");

			//update cookie
			const cookieVal = this.whichModal;
			let nextModal = cookieVal + 1;
			if (nextModal > 2) nextModal = 0;

			setCookie("tpm_next_modal", nextModal, 30); //30 days
			setCookie("tpm_dismissed_modal", 1, 0.125); //3 hours,
		} else if (this.state.large) {
			setCookie("tpm_dismissed_paywall", "1", 1);
		} else if (this.isFp) {
			setCookie("tpm_dismissed_small_modal", "1", 1);
		}

		this.setState({ closed: !this.state.closed });
	}

	toggleSize() {
		if (this.state.large) setCookie("tpm_dismissed_paywall", "1", "1");
		this.setState({ large: false });
	}

	get discountAmt() {
		if (this.state.views > 9) return "50%";
		else return "25%";
	}

	get isMobile() {
		return this.props.device === "mobile";
	}

	get isFp() {
		return this.props.fp;
	}

	get href() {
		let source = "on+site";
		let medium = this.state.large ? "wall" : "bumper";
		let campaign = "2023+spring";
		let content = this.isFp ? "frontpage" : "article";

		if (this.state.modal) {
			medium = "modal";
			switch (this.whichModal) {
				case 0:
					content = "Flood";
					break;
				case 1:
					content = "Results";
					break;
				case 2:
					content = "Bigs";
					break;
				default:
					break;
			}
		}

		return `${document.location.origin}/memberships?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}&utm_content=${content}`;
	}

	get viewCount() {
		const views = this.state.views;
		return `You've read ${views} article${views > 1 ? "s" : ""} this month`;
	}

	selectModalContent(i = 1) {
		const cont = {
			0: {
				title: "Built To Fight The Flood",
				imgSrc: `${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/small/bannon-flood.png`,
			},
			1: {
				title: "Small Team. Big Results.",
				imgSrc: `${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/small/meadows-texts-big-results.png`,
			},
			2: {
				title: (
					<span>
						What <i>They</i> Can't Be
					</span>
				),
				imgSrc: `${document.location.origin}/wp-content/themes/tpm25/assets/images/membership-drive-23/small/tpm-newspaper.png`,
			},
		};
		return cont[i];
	}

	renderContent() {
		// return this.renderModal();
		if (this.state.closed) return;
		if (this.state.modal) return this.renderModal();
		if (this.state.large) return this.renderPaywall();
		return this.renderSmall();
	}

	renderModal() {
		const content = this.selectModalContent(this.whichModal);
		return (
			<div class="MeteredModal23__Modal">
				<div class="MeteredModal23__ModalHeader">
					<b>LIMITED TIME OFFER</b>
					<div class="secondary">Discounted Prices End May 31st</div>
				</div>
				<div className="MeteredModal23__ModalMain">
					<div className="MeteredModal23__ModalTitle">{content.title}</div>
					<img
						class="MeteredModal23__ModalContentImage"
						src={content.imgSrc}
						alt="alt text"
					/>
					<div className="MeteredModal23__CTA">
						<a class="MeteredModal23__Button Button --red" href={this.href}>
							Get {this.discountAmt} off any TPM membership
						</a>

						<div
							class="MeteredModal23__ModalClose"
							onClick={() => {
								this.toggleClosed(true);
							}}
						>
							No thanks
						</div>
					</div>
				</div>
			</div>
		);
	}

	renderPaywall() {
		return (
			<div class="MeteredModal23__Inner --vertical">
				<div
					className="MeteredModal23__Close"
					style={{ display: "none" }}
					onClick={(event) => {
						event.stopPropagation();
						this.toggleClosed();
					}}
				>
					<Icon name="xmark" style="light" />
				</div>
				<div className="MeteredModal23__SmallHeader">
					DISCOUNT ENDS MAY 31ST
				</div>
				<div class="MeteredModal23__Flex --vertical">
					<div class="MeteredModal23__Count --margin-top">{this.viewCount}</div>
					<div className="MeteredModal23__Heading">
						BUT...THIS IS NOT A PAYWALL
					</div>
					<div className="MeteredModal23__Pitch">
						Thanks to the success of our recent membership drive, we are able to
						continue offering free access to all our journalism for an
						additional month. What makes this possible is the support of our
						regular readers, like you. If you are still on the fence about
						joining, consider making this the month you take the plunge. Our
						special discounted rates can’t last forever and your support makes
						all the difference in the world to us.{" "}
					</div>
					<a
						class="MeteredModal23__Button Button --red-hollow"
						href={this.href}
					>
						Get {this.discountAmt} off any TPM membership
					</a>
					<div className="MeteredModal23__Continue" onClick={this.toggleSize}>
						CONTINUE READING
						<Icon name="angle-down" style="light" />
					</div>
				</div>
			</div>
		);
	}

	renderSmall() {
		return (
			<div
				class={`MeteredModal23__Inner ${this.isFp ? "--fp --vertical" : ""}`}
			>
				<div
					className={`MeteredModal23__Close ${this.isFp ? "--visible" : ""}`}
					onClick={(event) => {
						event.stopPropagation();
						this.toggleClosed();
					}}
				>
					<Icon name="xmark" style="light" />
				</div>
				<div className="MeteredModal23__SmallHeader">
					DISCOUNT ENDS MAY 31ST
				</div>
				<div className="MeteredModal23__Flex">
					<div class="MeteredModal23__Count">{this.viewCount}</div>
					<a
						class="MeteredModal23__Button Button --red-hollow"
						href={this.href}
					>
						Get {this.discountAmt} off any TPM membership
					</a>
				</div>
			</div>
		);
	}
}
